import type { ReactNode } from 'react';
import { Panel } from '../Panel/Panel';
import { CardDecoration, type DecorationVariant } from '@src/theme/Decoration';
import './DecoratedCard.css';

export type DecoratedCardVariant = DecorationVariant;

export interface DecoratedCardProps {
  children: ReactNode;
  variant?: DecoratedCardVariant;
  edges?: boolean;
  motif?: boolean;
  className?: string;
}

/** Content-sized panel. Decorations keep their proportions at any card size. */
export function DecoratedCard({
  children,
  variant = 1,
  edges = true,
  motif = true,
  className = '',
}: DecoratedCardProps) {
  return (
    <Panel
      padding="none"
      elevated
      wide
      className={`decorated-card decorated-card--${variant} ${className}`}
    >
      <CardDecoration variant={variant} edges={edges} motif={motif} />
      <div className="decorated-card__content">{children}</div>
    </Panel>
  );
}
